export default __webpack_public_path__ + "media/images/53-ac863b021c90b061017f0d025724d140.png";